<template>
<div class="">
	<div class='locl-template text-center'>
		<b-icon icon="lock-fill" aria-hidden="true" variant="info" class='lock-icon-trz'></b-icon>
		<div class='lock-text'>
			This feature is not accesible.
		</div>
	</div>
</div>
</template>
<script>
    
    export default{

        props: [], 
		
		components: {

        }, 
		
		
	}
	
</script>

<style scoped>

.lock-text {
	font-size: 25px;
	padding-top: 15px;
}
.lock-icon-trz {
	font-size: 25px;
}
.locl-template {
	margin-top: 10%;
}

</style>